// extracted by mini-css-extract-plugin
export var modal = "_ka-0";